import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesFR from 'src/locales/fr.json';
import resourcesPT from 'src/locales/pt.json';
import resourcesES from 'src/locales/es.json';
import resourcesJP from 'src/locales/jp.json';

const lng = localStorage.getItem('lng') || 'en';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      ...resourcesFR,
      ...resourcesPT,
      ...resourcesES,
      ...resourcesJP
    },
    lng,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
